import { useEffect, useState } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { CrosswordEntry, wordToKey } from "../common/helpers";
import { StyledPanel, StyledVerticalFlex } from "./Styled";
import { ImportMetaEnv } from "../common/types";
import { SearchInput } from "./SearchInput";

const API_URL = (import.meta as ImportMetaEnv).env.VITE_API_URL as string;
console.log("API_URL", API_URL); // eslint-disable-line no-console

// Define the CrosswordEntry type; adjust fields as required

const StyledEntriesPage = styled.div(css`
  padding: 0rem;
  font-size: 1.5rem;
`);

const StyledEntryDiv = styled.div(
  () => css`
    padding: 0;
    margin: 0rem 0.25rem;

    p {
      margin: 0.25rem 0;
    }
  `
);

export function EntriesPage() {
  const [searchValue, setSearchValue] = useState(() => localStorage.getItem("entries-search-value") || "");
  const [entries, setEntries] = useState<CrosswordEntry[] | null>(null);

  useEffect(() => {
    localStorage.setItem("entries-search-value", searchValue);
  }, [searchValue]);

  useEffect(() => {
    if (!searchValue.trim()) {
      setEntries(null);
      return;
    }
    const url = `${API_URL}/api/entries`;
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clue: searchValue }),
    })
      .then((res) => res.json())
      .then((data: CrosswordEntry[]) => {
        setEntries(data);
      })
      .catch((error) => console.error("Error fetching entries:", error)); // eslint-disable-line no-console
  }, [searchValue]);

  return (
    <StyledEntriesPage>
      <h1>Entries</h1>
      <StyledVerticalFlex>
        <StyledPanel>
          <SearchInput
            delay={1000}
            onChange={(value) => {
              setSearchValue(value);
            }}
            initialValue={searchValue}
          />
        </StyledPanel>

        {/* Render the entries if available */}
        {entries && (
          <div style={{ marginTop: "0rem" }}>
            {entries.length === 0 ? (
              <p>No entries found.</p>
            ) : (
              entries.map((entry, i) => (
                <StyledEntryDiv key={i}>
                  <p>{wordToKey(entry)}</p>
                </StyledEntryDiv>
              ))
            )}
          </div>
        )}
      </StyledVerticalFlex>
    </StyledEntriesPage>
  );
} 